import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { RatingExplanationHeader } from "@src/appV2/redesign/Tiers/RatingsSection/RatingExplanationHeader";
import { type NormalizedRating } from "@src/appV2/redesign/Tiers/utils/types";

interface LateCancelRatingExplanationCardProps {
  workerNormalizedRating: NormalizedRating;
  targetNormalizedRating: NormalizedRating;
  header: string;
  onClick: () => void;
}

function getLateCancelExplanation(
  workerHasEvents: boolean,
  workerCountOfLateCancels: number,
  targetCountOfLateCancels: number
) {
  const prefix = "Work shifts instead of cancelling last-minute";
  if (!workerHasEvents || workerCountOfLateCancels === 0) {
    return `${prefix} to keep your clean slate`;
  }

  if (workerCountOfLateCancels <= targetCountOfLateCancels) {
    return `${prefix} to stay on track`;
  }

  return `${prefix} until your late ${
    workerCountOfLateCancels === 1 ? "cancel rolls" : "cancels roll"
  } off`;
}

export function LateCancelRatingExplanationCard(props: LateCancelRatingExplanationCardProps) {
  const { workerNormalizedRating, targetNormalizedRating, header, onClick } = props;
  const { ratingHasEvents: workerHasEvents, rating: workerCountOfLateCancels } =
    workerNormalizedRating;
  const { rating: targetCountOfLateCancels } = targetNormalizedRating;
  const lateCancelExplanation = getLateCancelExplanation(
    workerHasEvents,
    workerCountOfLateCancels,
    targetCountOfLateCancels
  );
  return (
    <Stack direction="column" gap={3} sx={{ cursor: "pointer" }} onClick={onClick}>
      <RatingExplanationHeader
        workerNormalizedRating={workerNormalizedRating}
        targetNormalizedRating={targetNormalizedRating}
        header={header}
        onClick={onClick}
      />
      <Stack direction="column" gap={2}>
        <Stack direction="row" alignItems="top" gap={2}>
          <CbhIcon
            type="diamond"
            size="small"
            sx={{ color: (theme) => theme.palette.text.secondary }}
          />
          <Text inline variant="body1" sx={{ color: (theme) => theme.palette.text.secondary }}>
            {lateCancelExplanation}
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
}
